import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { NICmsContentComponent } from '@icms/core/content';
import { CmsBlogCategoryViewComponent } from '../../../cms/blog/category';
import { CmsBlogPostViewComponent } from '../../../cms/blog/post';
import { CmsBlogRootViewComponent } from '../../../cms/blog/root';
import { PageViewAbstract } from './page-view.abstract';

declare module '@df/catalog/cms/cms-model.interface' {
    export interface IPageDataV2 {
        components: NICmsContentComponent.IData[];
    }
}

@Component({
    selector: 'page-view',
    templateUrl: 'page-view.component.html',
    styleUrl: './page-view.component.scss',
    standalone: true,
    imports: [CmsBlogCategoryViewComponent, CmsBlogPostViewComponent, CmsBlogRootViewComponent, DfImageDirective, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageViewComponent extends PageViewAbstract {}
